import React, { FC, useRef, useContext, useEffect } from 'react'
import { EventEmitter } from './EventEmitter'
import { EventsMap } from './EventEmitter.types'

type EventTypes = keyof EventsMap

interface EventEmitterValues {
  events: EventEmitter<EventsMap>
}

export const EventEmitterContext = React.createContext<EventEmitterValues>({
  events: new EventEmitter(),
})

export const EventEmitterProvider: FC = ({ children }) => {
  const eventsRef = useRef(new EventEmitter<EventsMap>())
  return (
    <EventEmitterContext.Provider value={{ events: eventsRef.current }}>
      {children}
    </EventEmitterContext.Provider>
  )
}

export const useEventDispatch = <T extends EventTypes>(event: T) => {
  const { events } = useContext(EventEmitterContext)

  return (data: EventsMap[T]) => {
    events.dispatch(event, data)
  }
}

export const useOnEvent = <T extends EventTypes>(
  event: T,
  callback: (data: EventsMap[T]) => void
) => {
  const { events } = useContext(EventEmitterContext)

  useEffect(() => {
    events.subscribe(event, callback)
    return () => events.unsubscribe(event, callback)
  }, [events, event, callback])
}
